import React from 'react';

import Card from '@components/libraryV2/Card';
import ContentWell from '@components/libraryV2/ContentWell';
import Heading from '@components/libraryV2/Heading';
import Text from '@components/libraryV2/Text';
import ThemeText from '@components/libraryV2/ThemeText';

import MobileFirstSvg from '@svg/generic/mobile-first.svg';
import PoweredBySvg from '@svg/generic/powered-by.svg';
import WrittenForHumansSvg from '@svg/generic/written-for-humans.svg';
import BuiltForSpeedSvg from '@svg/generic/built-for-speed.svg';

import * as styles from './styles.module.scss';

const Feature = ({ children, icon, title }) => (
  <Card className={styles.feature}>
    <div className={styles.icon}>{icon}</div>
    <div className={styles.content}>
      <Text size="wolf" weight="bold">
        {title}
      </Text>
      <div className={styles.children}>{children}</div>
    </div>
  </Card>
);

const Features = () => (
  <ContentWell secondary tighten reverseBackground withBackground>
    <Heading className={styles.heading} size="h2" tagType="h2">
      <div>The features and functionality</div> <ThemeText>you need to succeed</ThemeText>
    </Heading>

    <div className={styles.stinger}>
      <span>The best exam prep at the best price.</span>{' '}
      <span>That&apos;s our promise.</span>
    </div>

    <div className={styles.features}>
      <Feature icon={<MobileFirstSvg />} title="Mobile first">
        Unlike &quot;dumb&quot; mobile apps that are just a window to a desktop-based
        learning experience, we&apos;ve designed Achievable to be a best-in-class mobile
        experience.
      </Feature>
      <Feature icon={<PoweredBySvg />} title="Written for humans">
        Other exam prep material is dry and academic. We write our courses to be easy to
        read, using casual language and straightforward examples.
      </Feature>
      <Feature icon={<WrittenForHumansSvg />} title="Powered by learning science">
        Our algorithm optimizes your study schedule to help you remember the old content
        while learning the new. We take the hassle out of the when and why.
      </Feature>
      <Feature icon={<BuiltForSpeedSvg />} title="Built for speed">
        Our courses routinely takes students less time to complete than other courses,
        while achieving better results. That&apos;s the power of Achievable.
      </Feature>
    </div>
  </ContentWell>
);

export default Features;
